import axios from 'axios';
import axiosInstance from '../AxiosInstance';
import { API_URL } from '../../config';




export const CreateBranch = async (b, file) => {
    const formData = new FormData();
    formData.append('branch', JSON.stringify(b));
    // Check if file is [0] or invalid, and append null
    if (file && Array.isArray(file) && file.length > 0 && file[0] !== 0) {
        file.forEach((f) => {
            formData.append('icon', f); // Append each file with the same key
        });
    } else {
        formData.append('icon', null); // Append null if file is invalid or [0]
    }
    return await axiosInstance.post(`${API_URL}/createbranch`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
      
};
export const fetchBranches = () => {   
    
    return axiosInstance.get(`${API_URL}/getallbranches`, {
        
    })
};
export const fetchBranchadmin = () => {

    return axiosInstance.get(`${API_URL}/getallbranchesadmin`, {

    })
};

export const Createemployee = async (a) => {

    return axiosInstance.post(`${API_URL}/createemployee`, a
        , {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer your-access-token' // Optional, for authentication
            }
        });
};
export const FetchEmployee = async (b) => {

    return await axiosInstance.get(`${API_URL}/getemployee`
        , {
            
        });
};
export const deleteEmployeeById = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/deleteemployee/${id}`);
        return response.data; // Assuming the API returns JSON data
    } catch (error) {
        console.error('Error deleting employee:', error.response || error.message);
        throw error;
    }
};
export const deleteBranchById = async (id) => {
    try {
         debugger;
        const response = await axiosInstance.post(`${API_URL}/deletebranch/${id}`);
        return response.data; // Assuming the API returns JSON data
    } catch (error) {
        console.error('Error response:', error.response?.data || error.message);
        throw error;
    }
};
export const deletePartnerById = async (id) => {
    try {
         
        const response = await axiosInstance.post(`${API_URL}/deletepartner/${id}`);
        return response.data; // Assuming the API returns JSON data
    } catch (error) {
        console.error('Error response:', error.response?.data || error.message);
        throw error;
    }
};
export const fetchServiceCategory = () => {
    const token = localStorage.getItem('token');
    console.log('test')
    return axios.get(`${API_URL}/getallServiceCategory`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};

export const CreateService = async (b,file) => {

    const formData = new FormData();
    formData.append('service', JSON.stringify(b));
    // formData.append("brand", b); // Assuming `brandData` has your brand details
    formData.append("file", file);
    return await axiosInstance.post(`${API_URL}/createService`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

};

export const FetchService = async (b) => {

    return await axiosInstance.get(`${API_URL}/getallservices`
        , {
            
        });
};
export const FetchServiceByPartner = async () => {

    return await axiosInstance.get(`${API_URL}/getservicebypartner`
        , {

        });
}; 
export const FetchAdditionalByServiceID = async (id) => {

    return await axiosInstance.get(`${API_URL}/getadditionalbyservice/${id}`
        , {

        });
};
export const addPackage = async (b) => {

    return await axiosInstance.post(`${API_URL}/createpackage`, b
        , {
        });
};
export const updatePackage = async (b) => {

    return await axiosInstance.post(`${API_URL}/updatepackage`, b
        , {
        });
};



export const fetchBranchId = async (id) => {
        try {
            const response = await axiosInstance.get(`${API_URL}/getbranchbyid/${id}`);
            return response.data; // Ensure you return the correct data structure
        } catch (error) {
            throw new Error("Failed to fetch branch data: " + error.message);
        }
    };

export const UpdateBranch = async (updatedBranch, file) => {
    
    const formData = new FormData();
    formData.append('branch', JSON.stringify(updatedBranch));
    // Check if file is [0] or invalid, and append null
    if (file && Array.isArray(file) && file.length > 0 && file[0] !== 0) {
        file.forEach((f) => {
            formData.append('icon', f); // Append each file with the same key
        });
    } else {
        formData.append('icon', null); // Append null if file is invalid or [0]
    }
    return await axiosInstance.post(`${API_URL}/updatebranch`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
           
       
    };

export const fetchPartnerbyId = async (id) => {
        try {
            const response = await axiosInstance.get(`${API_URL}/getpartnerbyid/${id}`);
            return response.data; // Ensure you return the correct data structure
        } catch (error) {
            throw new Error("Failed to fetch partner data: " + error.message);
        }
};

export const regenerateActivationLink = async (partnerId) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/regenerateactivationlink/${partnerId}`);
        return response.data;
    } catch (error) {
        throw new Error("Failed to regenerate activation link: " + error.message);
    }
};

export const ApproveBranch = async (id) => {
    try {
    
        const response = await axiosInstance.post(`${API_URL}/approvebranch/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error approving branch:', error);
        throw error;
    }
};
export const ActivateBranch = async (id,value) => {
    try {
       
        const response = await axiosInstance.post(`${API_URL}/enablebranch/${id}/${value}`);
        return response.data;
    } catch (error) {
        console.error('Error approving branch:', error);
        throw error;
    }
};

export const UpdatePartner = async (b,file, iconFile) => {
    const formData = new FormData();
    formData.append('partner', JSON.stringify(b));
   // Check if file is [0] or invalid, and append null
    if (iconFile && Array.isArray(iconFile) && iconFile.length > 0 && iconFile[0] !== 0) {
        formData.append('Icon', iconFile[0]); // Append valid file
} else {
    formData.append('Icon', null); // Append null if file is invalid or [0]
}

// Check if iconFile is null or invalid
if (file ) {
    formData.append('Doc', file); // Append valid icon file
} else {
    formData.append('Doc', null); // Append null if iconFile is null or invalid
}

    return await axiosInstance.post(`${API_URL}/updatepartner`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
  
export const CreatePartner= async (b, file,iconFile) => {  
 
    const formData = new FormData();
    formData.append('partner', JSON.stringify(b));
   // formData.append("brand", b); // Assuming `brandData` has your brand details
    formData.append("Doc", file);
    formData.append("Icon", iconFile[0]);
    return await axiosInstance.post(`${API_URL}/createpartner`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const fetchServicebyId = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/getservicebyid/${id}`);
        return response; // Ensure you return the correct data structure
    } catch (error) {
        throw new Error("Failed to fetch partner data: " + error.message);
    }
};
export const fetchEmployeeById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/employee/${id}`);
        return response; // Ensure you return the correct data structure
    } catch (error) {
        throw new Error("Failed to fetch employee data: " + error.message);
    }
};
export const FetchProductCategory = async (id) => {
    try {
       
        const response = await axiosInstance.get(`${API_URL}/getallproductcategories`);
        return response; // Ensure you return the correct data structure
    } catch (error) {
        throw new Error("Failed to FetchProductCategory: " + error.message);
    }
};
export const CreateProduct = async (b) => {
    const response = await axiosInstance.post(`${API_URL}/branch/addproduct`,b);
    return response.data;
}

export const UpdateProduct = async (b) => {
    const response = await axiosInstance.post(`${API_URL}/branch/updateproduct`, b);
    return response.data;
} 
export const Updateemployee = async (updatedemployee) => {
     

    return await axiosInstance.post(`${API_URL}/updateemployee`, updatedemployee, {
       
    });
};

export const UpdateService = async (b, file) => {
    const formData = new FormData();
    formData.append('service', JSON.stringify(b));
    // formData.append("brand", b); // Assuming `brandData` has your brand details
    formData.append("file", file);
    return await axiosInstance.post(`${API_URL}/updateService`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
   
};

export const checkEmail = async (email) => {
        try {
            const response = await axiosInstance.get(`${API_URL}/checkemail`,
            {
            params: { email }  // Pass email as query parameter
        });
            return response.data; // Ensure you return the correct data structure
        } catch (error) {
            throw new Error("Failed to fetch partner data: " + error.message);
        }
};

export const ApproveService = async (id) => {
    try {
    
        const response = await axiosInstance.post(`${API_URL}/approveservice/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error approving service:', error);
        throw error;
    }
};
export const ApprovePackage = async (id) => {
    try {

        const response = await axiosInstance.get(`${API_URL}/approvepackage/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error approving service:', error);
        throw error;
    }
};

export const FetchPackageByPartner = async () => {

    return await axiosInstance.get(`${API_URL}/getpackagebypartner`
        , {

        });
}; 
export const FetchAllPackage = async () => {
    return await axiosInstance.get(`${API_URL}/getallpackage`
        , {

        });
};
export const FetchProductByPartner = async () => {

    return await axiosInstance.get(`${API_URL}/myproducts`
        , {

        });
};
export const FetchAllProducts = async () => {
    return await axiosInstance.get(`${API_URL}/products`
        , {

        });
};

export const FetchPackageById = async (id) => {

    return await axiosInstance.get(`${API_URL}/package/${id}`
        , {

        });
}; 
export const FetchProductById = async (id) => {

    return await axiosInstance.get(`${API_URL}/product/${id}`
        , {

        });
};

export const EnablePartnerbyID = async (id) => {
    try {

        const response = await axiosInstance.get(`${API_URL}/enablePartnerByID/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error enabling/disabling Partner:', error);
        throw error;
    }
};

export const checkPhonenumber = async (phone) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/checkphonenumber`,
        {
        params: { phone }  // Pass email as query parameter
    });
        return response.data; // Ensure you return the correct data structure
    } catch (error) {
        throw new Error("Failed to fetch partner data: " + error.message);
    }
};
export const createcoupon=async (c)=>{
     const response=await axiosInstance.post(`${API_URL}/createcoupon`,c);
     console.log(c);
     return response.data;
}
export const getallcoupon = async (id) => { 
    try { 
        
        const response = await axiosInstance.post(`${API_URL}/getallcoupon/${id}`);
        //console.log(JSON.stringify(response.data));
        return response.data;
        }
        catch (error) { 
            console.error('Error fetching coupons:', error); 
            throw error; 
        }
    };
export const getallcouponbypartner=async()=>{
    const response=await axiosInstance.post(`${API_URL}/getallcouponbypartner`);
    try{
        console.log(JSON.stringify(response.data));
        return response.data;
    }catch(error){
        throw error;
    }
}
export const getallcouponbyadmin=async()=>{
    
    try{
        const response=await axiosInstance.post(`${API_URL}/getallcoupon`);
        return response.data;
    }catch(error){
        throw error;
      
    }
    
}
export const disputedetailsbyadmin=async()=>{
    try{
        const response=await axiosInstance.get(`${API_URL}/alldispute`);
        return response.data;

    }catch(error){
        throw error;
    }

}
        